import ACTIONS from '../actions.js'

export function useEmailActions(dispatch) {
  return {
    addRecipient: () => dispatch({ type: ACTIONS.ADD_RECIPIENT }),
    removeRecipient: index =>
      dispatch({ type: ACTIONS.REMOVE_RECIPIENT, index }),
    updateRecipient: (index, value) =>
      dispatch({ type: ACTIONS.UPDATE_RECIPIENT, index, value }),
    addReceiver: () => dispatch({ type: ACTIONS.ADD_RECEIVER }),
    removeReceiver: index => dispatch({ type: ACTIONS.REMOVE_RECEIVER, index }),
    updateReceiver: (index, value) =>
      dispatch({ type: ACTIONS.UPDATE_RECEIVER, index, value }),
    toggleSendEmails: value =>
      dispatch({ type: ACTIONS.TOGGLE_SEND_EMAILS, value }),
    toggleReceiveEmails: value =>
      dispatch({ type: ACTIONS.TOGGLE_RECEIVE_EMAILS, value }),
    setEmailResults: value =>
      dispatch({ type: ACTIONS.SET_EMAIL_RESULTS, value }),
  }
}

export default useEmailActions
